(function ($) {
  window.selectOrNative = function(selector) {
    if (!Modernizr.touchevents) {
      $(selector).find('select').each(function(){
        new Select({
            el: this,
            alignToHighlighted: 'always'
        });
      });
    }
    else {
      $(selector).find('select').each(function(){
        $(this).selectTouch();
      });
    }
  }

  // replacement selectboxu, pokud mame touchscreen
  $.fn.selectTouch = function() {

    var text = $('<span/>', {
      class: 'select-text',
      html: $(this).find('option:selected').text()
    }).insertBefore($(this));

    $(this).addClass('select-touch');

    $(this).change(function() {
      text.html($(this).find('option:selected').text());
    });
  };

})(jQuery);

